import { noDataLightMode } from "../../assets/images";
import NoDataView from "./NoDataView";

interface InboxNoDataProps {
  onRetry?: () => void;
}

/**
 * Empty-state for the conversation inbox — mirrors mobile usage of NoData
 * with the "no threads" illustration and messaging.
 */
const InboxNoData = ({ onRetry }: InboxNoDataProps) => (
  <NoDataView
    image={noDataLightMode}
    title="No conversations yet"
    description="Your conversations will appear here once they are started."
    onRetry={onRetry}
    retryLabel="Refresh"
  />
);

export default InboxNoData;
